import { MessageService } from 'primeng';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CustomerService } from '../../services/customer.service';
import { ICustomerPremiumTimeBand } from '../../interfaces/customer-premium-timeband';

@Component({
  selector: 'manage-timeband-premiums',
  templateUrl: './manage-timeband-premiums.component.html',
  styleUrls: ['./manage-timeband-premiums.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ManageTimeBandPremiumsComponent implements OnInit {
  @Input() customerId: number;
  @Input() isReadonly: boolean;

  public selectedItem: any;
  public isLoaded: boolean = false;

  timeBandPremiums: ICustomerPremiumTimeBand[];
  selectedPremium: ICustomerPremiumTimeBand;
  newPremium: ICustomerPremiumTimeBand = { id: 0, minTime: 0, maxTime: 0, premiumPercentage: 0 };

  first: number;
  rows: number;
  sortField: any;
  sortOrder: any;

  showDeletePremiumDlg: boolean;
  showAddPremiumDlg: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public messageService: MessageService,
    private customerService: CustomerService,
  ) {}

  async ngOnInit() {
    this.first = 0;
    this.rows = 10;
    this.sortField = '';
    this.sortOrder = 1;

    await this.loadPremiums();

    this.isLoaded = true;
  }

  async loadPremiums() {
    this.timeBandPremiums = await this.customerService.getPremiumTimeBands(this.customerId);
    console.log(
      'Load premiums for customer: ',
      this.customerId,
      ' - result: ',
      this.timeBandPremiums,
    );
  }

  deletePremium() {
    this.showDeletePremiumDlg = true;
  }

  async deletePremiumConfirm(item) {
    await this.customerService.deletePremiumTimeBand(item.data.id);
    this.showDeletePremiumDlg = false;

    // reload premiums from db
    await this.loadPremiums();
  }

  async cellEdit(item: ICustomerPremiumTimeBand) {
    item.minTime = item.minTime || 0;
    item.maxTime = item.maxTime || 0;
    item.premiumPercentage = item.premiumPercentage || 0;

    // ensure current customerId is set in the item
    if (this.customerId) {
      item.customerId = this.customerId;
    }

    // save data
    await this.customerService.updatePremiumTimeBand(item);
  }

  addPremium() {
    this.showAddPremiumDlg = true;
  }

  async savePremium(newPremium: ICustomerPremiumTimeBand) {
    // ensure current customerId is set in the item if applicable
    if (this.customerId) {
      newPremium.customerId = this.customerId;
    }

    // save data
    await this.customerService.addPremiumTimeBand(newPremium);

    this.showAddPremiumDlg = false;

    // reload premiums from db
    await this.loadPremiums();
  }

  onRowClick($event: any) {
    this.selectedPremium = $event;
  }
}
